import { LogIn, User } from 'react-feather';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '@/core/auth/useAuth';
import { UserAvatar } from '@/shared/ui/UserAvatar';

/** CUBA UserHeader — profile hover dropdown */
export function UserHeader() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const onLogout = () => {
    logout();
    navigate('/login', { replace: true });
  };

  return (
    <li className="profile-nav onhover-dropdown pe-0 py-0">
      <div className="media profile-media">
        <UserAvatar fullName={user?.fullName} avatarUrl={user?.avatarUrl} size={40} />
        <div className="media-body">
          <span>{user?.fullName ?? 'User'}</span>
          <p className="mb-0 font-roboto text-capitalize">
            {(user?.role ?? '').replace(/_/g, ' ') || 'Account'}{' '}
            <i className="middle fa fa-angle-down" />
          </p>
        </div>
      </div>
      <ul className="simple-list profile-dropdown onhover-show-div">
        <li>
          <Link to="/account" className="d-flex align-items-center gap-2 text-reset">
            <User />
            <span>Profile</span>
          </Link>
        </li>
        <li onClick={onLogout} role="button" tabIndex={0}>
          <LogIn />
          <span>Log out</span>
        </li>
      </ul>
    </li>
  );
}
